import {createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


const cryptoNewsHeader={
    'x-bingapis-sdk': 'true',
    'x-rapidapi-host': 'bing-news-search1.p.rapidapi.com',
    'x-rapidapi-key': 'a0f56d12c9msh65e68ee0f69200bp146854jsn65db25efcdd5'
};

const baseUrl='https://bing-news-search1.p.rapidapi.com';

const createRequst =(url)=>({url, headers:cryptoNewsHeader});

export const cryptoNewsApi= createApi({
    reducerPath:'cryptoNewsApi',
    baseQuery:fetchBaseQuery({baseUrl}),
    endpoints: (builder)=>({
        getCryptoNews: builder.query({
            query: ({newsCategory,count})=> createRequst(`/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`),
        })
    })

});

export const {useGetCryptoNewsQuery}=cryptoNewsApi;